import React from 'react';
import { HelperLine, HelperText, ErrorMessage } from './mixins';
export const Helper = ({ name, fieldOptions, errors, noBottomMargin = false }) => {
    if (!(fieldOptions && !!fieldOptions.helperText) && !(errors && errors[name]) && noBottomMargin)
        return null;
    return (React.createElement(HelperLine, { id: `${name}-helper-line` },
        errors && errors[name] && React.createElement(ErrorMessage, null, errors[name].message),
        fieldOptions && fieldOptions.helperText && !(errors && errors[name]) && (React.createElement(HelperText, null, fieldOptions.helperText))));
};
